const footer = {
  "footer.cookie": "Cookie Settings",
  "footer.about": "TENTANG ACUVUE® DEFINE®",
  "footer.contact": "KONTAK KAMI",
  "footer.policy": "KEBIJAKAN PRIVASI",
  "footer.notice": "PEMBERITAHUAN HUKUM",
  "footer.legal": "<p>PT Johnson And Johnson Indonesia Two. Semua hak dilindungi undang-undang. Situs ini diterbitkan oleh Johnson & Johnson Vision, yang bertanggung jawab penuh atas kontennya. Ditujukan untuk digunakan oleh penduduk Indonesia.</p> <p> ACUVUE® OASYS, HydraLuxe®, MOIST, DEFINE®, Natural Shine®, Radiant Charm™, Radiant Chic™, LACREON®, HYDRACLEAR® PLUS, INTUISIGHT™, EYELID STABILIZED DESIGN adalah trademarks dari Johnson & Johnson Vision ©, PT Johnson And Johnson Indonesia Two. </p>",
}

export default footer






